import { memo } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { ButtonPrimary } from '../../../../../components';
import { useEditedPriceManagerStore } from '../../../../../store/priceManagerStore';
import { ButtonDropdown } from '../ButtonDropdown';
import useAppyPricesButton from './useAppyPricesButton';

const CTA_BUTTON_ID = 'apply-prices-btn';

const AppyPricesButton = () => {
  const { isDisabled, isDisabledOption, placeholder, handleApplyPrices, isLoading } = useAppyPricesButton();
  const { isPendingEditedPrice } = useEditedPriceManagerStore();
  const displayType = useSelector((state: RootState) => state.datapointExhibitionType.datapointExhibitionType);

  const disabled = isDisabled || isLoading || isPendingEditedPrice;
  const isProduct = displayType === 'PRODUCT';

  const handleClick = () => handleApplyPrices(!isProduct);
  const handleSelect = (itemId: string) => {
    if (itemId === 'APPLY_TO_FAMILY') {
      handleApplyPrices(true);
    }
  };

  if (isProduct) {
    return (
      <ButtonDropdown
        id={CTA_BUTTON_ID}
        disabled={disabled}
        isLoading={isLoading}
        onClick={handleClick}
        onSelectOption={handleSelect}
        skin="blue"
        options={[
          {
            id: 'APPLY_TO_FAMILY',
            label: 'Aplicar na Família',
            value: 'APPLY_TO_FAMILY',
            disabled: isDisabledOption || isLoading || isPendingEditedPrice,
            placeholder,
          },
        ]}
      >
        {isPendingEditedPrice ? <Loader size="sm" className="mr-2" /> : 'Aplicar preço'}
      </ButtonDropdown>
    );
  }

  return (
    <ButtonPrimary id={CTA_BUTTON_ID} disabled={disabled} isLoading={isLoading} onClick={handleClick}>
      {isPendingEditedPrice ? <Loader size="sm" className="mr-2" /> : 'Aplicar preço'}
    </ButtonPrimary>
  );
};

export default memo(AppyPricesButton);
